import { Form, Formik } from "formik";
import "moment-timezone";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import shortid from "shortid";
import * as Yup from "yup";
import FormikInputControl from "../../../Shared/Forms/FormikInputControl";

const EditRegularAvailability = ({ regularAvailability, update, cancel }) => {
  const [ra, setRa] = useState()

  useEffect(() => {
    setRa(regularAvailability);
  }, [regularAvailability]);

  const StartEnd = ({ day, index, errors, touched }) => {
    const fromError = errors[day.toLowerCase()] && errors[day.toLowerCase()][index] && errors[day.toLowerCase()][index].from;
    const toError = errors[day.toLowerCase()] && errors[day.toLowerCase()][index] && errors[day.toLowerCase()][index].to;
    return (
      <div style={{ display: "flex", marginRight: 30 }}>
        <FormikInputControl
          fieldLabel="Start"
          fieldName={`${day.toLowerCase()}.${index}.from`}
          errors={errors}
          touched={touched}
          style={{ width: 60 }}
          placeholder="00:00"
          className={`form-group ${fromError && "has-error"}`}
        />
        <span style={{ margin: "30px 5px 0 5px" }}>to</span>
        <FormikInputControl
          fieldLabel="End"
          fieldName={`${day.toLowerCase()}.${index}.to`}
          errors={errors}
          touched={touched}
          style={{ width: 60 }}
          placeholder="00:00"
          className={`form-group ${toError && "has-error"}`}
        />
      </div>
    );
  }

  const dayHoursValidation = Yup.object().shape({ from: Yup.string().matches(/^$|^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/, "HH:MM"), to: Yup.string().matches(/^$|^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,"HH:MM") })
  const validationSchema = Yup.object().shape({
    monday: Yup.array().of(dayHoursValidation),
    tuesday: Yup.array().of(dayHoursValidation),
    wednesday: Yup.array().of(dayHoursValidation),
    thursday: Yup.array().of(dayHoursValidation),
    friday: Yup.array().of(dayHoursValidation),
    saturday: Yup.array().of(dayHoursValidation),
    sunday: Yup.array().of(dayHoursValidation),
  });

  const submitForm = (values, { setSubmitting, setFieldError,validateForm, ...props }) => {
    const hoursBoth = (day, idx) => {
      if (values[day] && values[day][idx]) {
        const from = values[day][idx].from;
        const to = values[day][idx].to;
        if (from && from.length > 0 && (!to || to.length === 0)) {
          return false;
        }
        if (to && to.length > 0 && (!from || from.length === 0)) {
          return false;
        }
        if (from === to && from && to && from.length > 0 && to.length > 0) return false;
      }
      return true;
    };

    const allDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => {
      const hoursBothValid = hoursBoth(day.toLowerCase(), 0) && hoursBoth(day.toLowerCase(), 1) && hoursBoth(day.toLowerCase(), 2) && hoursBoth(day.toLowerCase(), 3)
      if (!hoursBothValid) setFieldError("form", "Start and End hours must both be provided (or neither), and not be the same");
      return hoursBothValid;
    })

    if (allDays.every((d) => d)) validateForm().then(() => {
      const result = {
        id: shortid.generate(),
        monday: values["monday"].map((d) => { return d.from && d.to && d.from.length > 0 && d.to.length > 0 ? { from: d.from, to: d.to } : null }).filter((d) => d !== null),
        tuesday: values["tuesday"].map((d) => { return d.from && d.to && d.from.length > 0 && d.to.length > 0 ? { from: d.from, to: d.to } : null }).filter((d) => d !== null),
        wednesday: values["wednesday"].map((d) => { return d.from && d.to && d.from.length > 0 && d.to.length > 0 ? { from: d.from, to: d.to } : null }).filter((d) => d !== null),
        thursday: values["thursday"].map((d) => { return d.from && d.to && d.from.length > 0 && d.to.length > 0 ? { from: d.from, to: d.to } : null }).filter((d) => d !== null),
        friday: values["friday"].map((d) => { return d.from && d.to && d.from.length > 0 && d.to.length > 0 ? { from: d.from, to: d.to } : null }).filter((d) => d !== null),
        saturday: values["saturday"].map((d) => { return d.from && d.to && d.from.length > 0 && d.to.length > 0 ? { from: d.from, to: d.to } : null }).filter((d) => d !== null),
        sunday: values["sunday"].map((d) => { return d.from && d.to && d.from.length > 0 && d.to.length > 0 ? { from: d.from, to: d.to } : null }).filter((d) => d !== null),
      };

      update(result);
    })

    setSubmitting(false);
  };
  if (!ra) return null

  return (
    <div style={{ minWidth: 450 }}>
      <h4>Edit Regular Hours</h4>

      <Formik
        initialValues={ra}
        validationSchema={validationSchema}
        onSubmit={submitForm}
        render={({
          errors,
          touched,
          isSubmitting,
          setFieldValue,
          setFieldTouched,
          validateForm,
        }) => {

          return (
            <Form>
              <table className="table table-condensed table-zebra">
                <tbody>
                  {[
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                    "Sunday",
                  ].map((day) => {
                    return (
                      <tr key={day}>
                        <td>
                          <strong>{day}</strong>
                        </td>
                        <td>
                          <div
                            style={{ display: "flex", displayDirection: "row" }}
                          >
                            <StartEnd
                              day={day}
                              index={0}
                              errors={errors}
                              touched={touched}
                            />
                            <StartEnd
                              day={day}
                              index={1}
                              errors={errors}
                              touched={touched}
                            />
                            <StartEnd
                              day={day}
                              index={2}
                              errors={errors}
                              touched={touched}
                            />
                            <StartEnd
                              day={day}
                              index={3}
                              errors={errors}
                              touched={touched}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>

              <div className={`form-group ${errors["form"] && "has-error"}`}>
                <span className="help-block">{errors && errors["form"]}</span>
              </div>

              <Button
                onClick={cancel}
                bsSize="small"
                className="mr-2"
              >
                Cancel Changes
              </Button>

              <Button
                disabled={isSubmitting}
                type="submit"
                bsStyle="info"
                bsSize="small"
              >
                Update Regular Hours
              </Button>
            </Form>
          );
        }}
      />
    </div>
  );
};

export default EditRegularAvailability;
